import { Document } from '../models';

export const MOCK_DOCUMENTS: Document[] = [
  {
    id: 'doc-1',
    title: 'Privacy Policy',
    name: 'Privacy Policy',
    publicSlug: 'privacy-policy',
    currentFileName: 'privacy_policy_2024.pdf',
    uploadedAt: '2024-01-01T10:00:00Z',
    uploadedBy: 'System Admin',
    fileSize: 1024 * 350,
  },
  {
    id: 'doc-2',
    title: 'Terms of Service',
    name: 'Terms of Service',
    publicSlug: 'terms-of-service',
    currentFileName: 'tos_updated.pdf',
    uploadedAt: '2024-02-15T15:30:00Z',
    uploadedBy: 'Legal Team',
    fileSize: 1024 * 450,
  },
  {
    id: 'doc-3',
    title: 'User Guide',
    name: 'User Guide',
    publicSlug: 'user-guide',
    currentFileName: 'user_manual_v1.pdf',
    uploadedAt: '2024-03-01T09:00:00Z',
    uploadedBy: 'Content Editor',
    fileSize: 1024 * 2500,
  },
];
